























import { Component, Prop, Vue } from 'vue-property-decorator';
import { PointStyleRule, PointStyleRuleColor } from '../models/pointStyleRule';

@Component
export default class MapLegend extends Vue {
  @Prop() private pointStyleRules!: PointStyleRule[];
  
  private quantityText(pointStyleRule: PointStyleRule): string {
    return (pointStyleRule.quantityTo === null ? '> ' : '') +
           (pointStyleRule.quantityFrom !== null ? this.formatNumber(pointStyleRule.quantityFrom) : '0') +
           (pointStyleRule.quantityTo !== null ? ' – ' + this.formatNumber(pointStyleRule.quantityTo) : '');
  }

  private formatNumber(value: number): string {      
      const formatter = new Intl.NumberFormat('sv-SE', {
          style: 'decimal',             
      });
      return formatter.format(value);
  }

  private fillColor(pointStyleRule: PointStyleRule): string {
    if (pointStyleRule.color === PointStyleRuleColor.Red) {
      return '#e4624a'; // sass variable $red
    }
    else if (pointStyleRule.color === PointStyleRuleColor.Yellow) {
      return '#ffeb46'; // sass variable $yellow
    }
    else if (pointStyleRule.color === PointStyleRuleColor.Green) {
      return '#00854a'; // sass variable $sodraGreen
    }
    return '';
  }
}
